// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__LCE+d","tooltip":"styles_tooltip__abJdJ"};